import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { getArticleById, getArticleNavigation } from '../data/articles';
import ArticleHeader from '../components/blog/ArticleHeader';
import ArticleAuthor from '../components/blog/ArticleAuthor';
import ArticleContent from '../components/blog/ArticleContent';
import ArticleNavigation from '../components/blog/ArticleNavigation';

const BlogArticlePage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  
  const article = getArticleById(id || '');
  const navigation = getArticleNavigation(id || '');

  if (!article) {
    navigate('/');
    return null;
  }

  return (
    <div className="pt-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Link 
          to="/" 
          className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to News
        </Link>

        <article>
          <img 
            src={article.image} 
            alt={article.title}
            className="w-full h-[400px] object-cover rounded-2xl mb-8"
          />

          <ArticleHeader
            category={article.category}
            date={article.date}
            readTime={article.readTime}
          />

          <h1 className="text-4xl font-bold text-gray-900 mb-6">{article.title}</h1>

          <ArticleAuthor
            name={article.author.name}
            avatar={article.author.avatar}
          />

          <ArticleContent content={article.content} />
        </article>

        <ArticleNavigation
          prev={navigation.prev}
          next={navigation.next}
        />
      </div>
    </div>
  );
};

export default BlogArticlePage;